export const CP_PAYMENT_STATUS_FAILURE = 'Failure';
export const CP_PAYMENT_STATUS_SUCCESS = 'Success';

export const CP_SWIPED = 'MSR';
